import React, { useState, useEffect } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import LeftNavigationArrow from "../../Assets/Icons/LeftNavigationArrow";
import CustomApparel from "../../Assets/Images/Apparel/CustomApparel.png";
import CustomUniforms from "../../Assets/Images/Apparel/CustomUniforms.png";
import Equipment from "../../Assets/Images/Apparel/Equipment.png";
import OnlineStores from "../../Assets/Images/Apparel/OnlineTeamStores.png";
import FacilityBrand from "../../Assets/Images/Apparel/FacilityBranding.png";
import MidBanner from "../../Assets/Images/Apparel/mid-banner.png";
import MobileFooterdBanner from "../../Assets/Images/Apparel/m-mobile-banner.png";
import footerBanner from "../../Assets/Images/Apparel/footer-banner.png";
import StoreCard from "./StoreCard/StoreCard";

const EquipmentApparelStore = () => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Listen for window resize to toggle mobile assets
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const cards = [
    {
      image: CustomApparel,
      heading: "Custom Apparel",
      paragraph:
        "High-quality branded gear including t-shirts, hoodies, shorts, and more—customized with your team or school logo.",
    },
    {
      image: CustomUniforms,
      heading: "Custom Uniforms",
      paragraph:
        "Fully customized uniforms for all sports, designed for performance, durability, and a professional look.",
    },
    {
      image: Equipment,
      heading: "Equipment",
      paragraph:
        "Access to essential sports equipment including balls, training tools, cones, and more—sourced from trusted brands.",
    },
    {
      image: OnlineStores,
      heading: "Online Team Stores",
      paragraph:
        "Personalized online stores for your team or organization, making ordering easy for players, parents, and staff.",
    },
    {
      image: FacilityBrand,
      heading: "Facility Branding",
      paragraph:
        "Upgrade your gym, field, or facility with banners, signage, and custom branding solutions.",
    },
  ];

  const processSteps = [
    {
      id: 1,
      title: "Consultation",
      description: "We discuss your program's needs, goals and budget",
    },
    {
      id: 2,
      title: "Product Selection",
      description: "Choose from a wide range of apparel and equipment options",
    },
    {
      id: 3,
      title: "Customization",
      description: "Add logos, colors and branding to match your organization",
    },
    {
      id: 4,
      title: "Delivery",
      description:
        "Fast and reliable delivery directly to your team or facility.",
    },
  ];

  return (
    <div className="eas-wrapper">
      {/* ── Header ── */}
      <div className="eas-header">
        <Link onClick={() => navigate(-1)} className="eas-back-btn">
          <LeftNavigationArrow />
        </Link>
        <h1 className="eas-title black-text-clip text-center">
          Equipment &amp; Apparel Store
        </h1>
      </div>

      {/* ── Intro Section ── */}
      <div className="eas-intro">
        <h2 className="eas-intro-heading black-text-clip">
          Equipment &amp; Apparel Store
        </h2>
        <p className="eas-intro-subtitle black-text-clip">
          Your one-stop shop for high-quality sports equipment, custom apparel,
          and
          <br />
          team gear—built to support athletes, schools, and programs at every
          level.
        </p>
        <p className="eas-intro-body">
          <span className="eas-brand black-text-clip">BWC Sports</span>{" "}
          <span className="black-text-clip">
            provides complete equipment and apparel solutions for schools,
            teams, and organizations. From custom uniforms to essential training
            gear, we partner with top brands to deliver high-quality products
            tailored to your program's needs. Whether you're outfitting a single
            team or an entire school, our streamlined process makes ordering
            simple and efficient.
          </span>
        </p>
      </div>

      {/* ── Cards Row ── */}
      <div className="store-cards-row">
        {cards.map((card) => (
          <StoreCard key={card.heading} {...card} />
        ))}
      </div>

      {/* ── Mid Banner (Static Image) ── */}
      <div
        className="mid-banner"
        style={{ backgroundImage: `url(${MidBanner})` }}
      >
        <div className="mid-banner-text">
          <span className="mid-banner-sub">Built for Athletes.</span>
          <h3 className="mid-banner-heading">Designed for Performance.</h3>
        </div>
      </div>

      {/* ── Why Choose Section ── */}
      <div className="why-choose-section">
        <h2 className="why-choose-heading">Why Choose BWC Sports?</h2>
        <p className="why-choose-text black-text-clip">
          At BWC Sports, we go beyond just providing products—we deliver
          complete solutions. Our team works directly with schools and
          organizations to ensure every order meets your exact needs, timeline,
          and budget. With a focus on quality, reliability, and service, we make
          it easy to outfit your athletes with confidence.
        </p>
      </div>

      {/* ── Process Section ── */}
      <div className="process-section">
        <h2 className="process-heading black-text-clip">
          Simple &amp; Efficient Process
        </h2>

        <div className="process-steps-container">
          {processSteps.map((step) => (
            <div className="process-step" key={step.id}>
              <div className="process-step-header">
                <div className="process-step-number">{step.id}</div>
                <h3 className="process-step-title black-text-clip">
                  {step.title}
                </h3>
              </div>
              <p className="process-step-desc black-text-clip">
                {step.description}
              </p>
              <div className="process-step-line"></div>
            </div>
          ))}
        </div>
      </div>

      {/* ── Footer Banner Section (Dynamic Image) ── */}
      <div className="footer-cta-container">
        <div
          className="footer-cta-banner"
          style={{
            backgroundImage: `url(${isMobile ? MobileFooterdBanner : footerBanner})`,
            filter: "brightness(0.86)",
          }}
        >
          <div className="footer-cta-content">
            <h2 className="footer-cta-heading">Get Started Today</h2>
            <p className="footer-cta-text">
              <span className="black-text-clip">
                Ready to upgrade your team’s gear or set up your custom store?
              </span>
              <br />
              <span className="black-text-clip">
                Contact BWC Sports today and let us build a solution tailored to
                your program.
              </span>
            </p>
            <div className="footer-cta-buttons">
              <button className="cta-btn btn-quote"
              onClick={() => navigate("/contact-us#hl-contact-us")}
              >Request a Quote</button>

              <Link to="/contact-us#hl-contact-us" className="cta-link-wrapper">
                <button className="cta-btn btn-contact">Contact Us</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EquipmentApparelStore;
